import { noop } from "lodash/fp";
import React, { createContext, useContext, useMemo, useState } from "react";

export interface AuthContextProps extends UserData {
  setUser: (data: UserData) => void;
}

export interface UserData {
  user: any | undefined;
  credentials: Credentials | undefined;
}

export interface Credentials {
  normalizedEmail: string;
  password: string;
}

const AuthContext = createContext<AuthContextProps>({
  user: undefined,
  credentials: undefined,
  setUser: noop,
});

export const AuthContextProvider: React.FC = ({ children }) => {
  const [{ user, credentials }, setUser] = useState<UserData>({ user: undefined, credentials: undefined });

  const value = useMemo<AuthContextProps>(
    () => ({
      user,
      credentials,
      setUser,
    }),
    [user, credentials, setUser]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuthContext = () => useContext(AuthContext);
